import React from "react";
import { Container } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { beliefSections, siteMeta } from "../data/siteContent";

function BeliefsPage() {
  return (
    <>
      <PageHero
        eyebrow="Beliefs"
        title="What We Believe"
        intro="What a church believes shapes how it worships, lives, teaches, and serves. Our beliefs are rooted in the Holy Scriptures, which are our supreme and final authority for faith and life."
        metaTitle={`Beliefs | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <div className="doctrine-layout">
            <aside className="doctrine-nav">
              <h3>Doctrine Navigation</h3>
              <ul>
                {beliefSections.map((item) => (
                  <li key={item.title}>
                    <a href={`#${item.title.replace(/\s+/g, "-").toLowerCase()}`}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </aside>
            <div className="doctrine-panels">
              {beliefSections.map((item) => (
                <article
                  key={item.title}
                  id={item.title.replace(/\s+/g, "-").toLowerCase()}
                  className="content-panel"
                >
                  <h2>{item.title}</h2>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default BeliefsPage;
